/**
 * supabase.js
 *
 * Initialises and exports a single shared Supabase client instance.
 * Import `supabase` from this module wherever you need to interact
 * with the database, auth, storage, or edge functions.
 *
 * Required environment variables (set in .env):
 *   VITE_SUPABASE_URL      – your project's REST/API URL
 *   VITE_SUPABASE_ANON_KEY – the public anon key (safe to expose in the browser)
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Fail fast at startup if the required env vars are absent
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. ' +
    'Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Automatically refresh the JWT before it expires
    autoRefreshToken: true,
    // Persist the session across page reloads (stored in localStorage)
    persistSession: true,
  },
});
